import { render, staticRenderFns } from "./DashboardWeeklyView.vue?vue&type=template&id=4855d0e3"
import script from "./DashboardWeeklyView.vue?vue&type=script&lang=js"
export * from "./DashboardWeeklyView.vue?vue&type=script&lang=js"
import style0 from "./DashboardWeeklyView.vue?vue&type=style&index=0&id=4855d0e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports